import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  go(event) {
    event.preventDefault()
    
    // Attempt to parse the href to find the ID
    const href = this.element.getAttribute("href")
    if (!href || !href.startsWith("#")) return
    
    const targetId = href.substring(1)
    const targetElement = document.getElementById(targetId)
    
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" })
    }
  }
}
